import { forwardRef, type SelectHTMLAttributes, type ReactNode } from "react";

interface SelectFieldProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: ReactNode;
  helperText?: string;
  error?: string;
  options: Array<{ value: string; label: string }>;
  className?: string;
  selectClassName?: string;
}

export const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(
  (
    {
      label,
      helperText,
      error,
      options,
      className = "",
      selectClassName = "",
      ...selectProps
    },
    ref,
  ) => {
    return (
      <div className={`space-y-2 ${className}`.trim()}>
        {label && (
          <label className="text-label" htmlFor={selectProps.id}>
            {label}
          </label>
        )}
        <select
          ref={ref}
          className={`input-compact w-full ${selectClassName}`.trim()}
          {...selectProps}
        >
          {options.map((option, index) => (
            <option
              key={`${String(option.value ?? "")}-${index}`}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
        {helperText && !error && (
          <p className="text-size-2xs text-global-tertiary">{helperText}</p>
        )}
        {error && <p className="text-size-2xs text-global-error">{error}</p>}
      </div>
    );
  },
);

SelectField.displayName = "SelectField";
